// Settles an optional read into { value, failed } so a failure is reported
// rather than standing in as an empty result.
export const settledRead = (promise) =>
    Promise.resolve(promise).then(
        (value) => ({ value, failed: false }),
        () => ({ value: null, failed: true })
    );

export default settledRead;
